import { Message } from '@ynap/address-form-v1'
import { formatPrice } from '@ynap/intl-formatters'
import { Adjustment, PromotionCode } from 'app/types/common-types'

const REWARDS_SEGMENTS = ['LOS_BRONZE', 'LOS_SILVER', 'LOS_GOLD', 'LOS_EIP', 'LOS_EIPPLATINUM']

type Benefit  = {
    code: string;
    description: string;
    amount: number;
    isFreeShipping: boolean;
    isExclusive: boolean;
}

const isExclusiveReward = (adjustment: Adjustment): boolean => {
    const { xadju_restrictedToSegments } = adjustment
    return xadju_restrictedToSegments?.length > 0 && REWARDS_SEGMENTS.some((segment) => xadju_restrictedToSegments?.includes(segment))
}

export default function getPromotionsAndRewards(appliedPromotions: PromotionCode[], adjustments: Adjustment[] = [], messages: Message, localeId: string) {
    const getBenefit = (code, description, amount, currency, usage, isExclusive) => {
        const isFreeShipping = amount.amount === 0 || usage === 'Shipping Adjustment'
        return {
            code,
            description,
            amount: isFreeShipping
                ? messages?.totals.zeroShippingPrice()
                : formatPrice(amount.amount / amount.divisor, currency.label, localeId),
            isFreeShipping,
            isExclusive
        }
    }
    const rewards = adjustments.reduce((acc, adjustment) => {
        const { code, description, amount, currency, usage } = adjustment

        return isExclusiveReward(adjustment) ? [...acc, getBenefit(code, description, amount, currency, usage, true)] : acc
    }, [])

    const promotions = appliedPromotions?.reduce((acc, appliedPromo) => {
        const { code, associatedPromotion } = appliedPromo

        if (typeof associatedPromotion === 'undefined') {
            return [
                ...acc,
                {
                    code: code,
                    amount: 0,
                    isExpired: true,
                },
            ]
        }

        const benefits: Benefit[] = []
        associatedPromotion?.forEach((promo) => {
            adjustments
                .filter((item) => item.code.includes(promo.promotionId))
                .forEach((item) => {
                    benefits.push(getBenefit(code, promo.description, item.amount, item.currency, item.usage, isExclusiveReward(item)))
                })
        })
        return [...acc, ...benefits]
    }, [])

    return { promotions, rewards }
}
